import { render, staticRenderFns } from "./StudioJoin.vue?vue&type=template&id=4d85c6f2&scoped=true&"
import script from "./StudioJoin.vue?vue&type=script&lang=js&"
export * from "./StudioJoin.vue?vue&type=script&lang=js&"
import style0 from "./StudioJoin.vue?vue&type=style&index=0&id=4d85c6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85c6f2",
  null
  
)

export default component.exports